module.exports = __webpack_public_path__ + "static/media/dirad_logo.d25efccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dirad_logo.png
// module id = 185
// module chunks = 0